export const getValidationMessage = validationResult => validationResult.errors[0] && validationResult.errors[0].message;